// Le nom de la commune consultée, pour les graphiques (revue de #773 : Marc veut « Besançon » au
// centre de l'anneau « Structure » et sur sa puce, pas le libellé servi « Ma commune »).
// `ChartBlock` ne connaît que son spec ; la page qui sait de quelle commune il s'agit (ThemeView,
// page d'un lien partagé) pose ce contexte. Absent (`null`) : la vue EPCI, le laboratoire, les
// maquettes — la commune garde le libellé servi. Fichier à part : un module de composant
// n'exporte que des composants (rechargement à chaud de Vite).
import { createContext } from 'react'

export const NomCommuneCtx = createContext<string | null>(null)
